import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 32px 142px 40px 142px;

  @media (max-width: 768px) {
    padding: 24px 16px 32px;
  }
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const BackArrowWrapper = styled.div`
  margin: 10px 12px;
`;

export const PageHeaderText = styled.h3`
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #1f2937;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 26px;
  }
`;

export const PageSubheaderText = styled.h6`
  font-size: 14px;
  line-height: 140%;
  font-weight: 400;
  color: #374151;
  margin-top: 4px;
`;

export const PersonalInfoInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 16px;
`;

export const InputAdnLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
`;

export const PersonalInfoInputLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #1f2937;
  flex: 1;
`;

export const PersonalInfoInput = styled.input`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #1f2937;
  padding: 16px;
  border: 1.5px solid #e5e7eb;
  border: ${(props) =>
    props.hasError ? "1.5px solid #E6000F" : "1.5px solid #e5e7eb"};
  border-radius: 4px;
  height: 48px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
`;

export const FlagAndIndex = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px;
  position: absolute;
  background: #e5e7eb;
  border-right: 1.5px solid #e2e8f0;
  border: ${(props) =>
    props.hasError ? "1.5px solid #E6000F" : "1.5px solid #e5e7eb"};
  bottom: 0;
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 48px;
`;

export const IndexText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #374151;
`;

export const ConsentInputWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  margin-bottom: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
`;

export const CheckboxInputAndLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  gap: 16px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #374151;
  padding: 16px 24px;
  cursor: pointer;
  background: ${(props) => (props.isChecked ? "#F0FDF4" : "#f9fafb")};
  position: relative;

  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
  }

  @media (max-width: 480px) {
    gap: 10px;
    padding: 14px;
  }
`;

export const CheckboxErrorIndicator = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid #e6000f;
  position: absolute;
  border-radius: 4px;
  left: 22px;
  z-index: 1;

  @media (max-width: 768px) {
    left: 14px;
  }
`;
export const Checkbox = styled.input`
  min-width: 20px;
  min-height: 20px;
  border-radius: 4px;

  width: 20px;
  height: 20px;
  z-index: 2;

  @media (max-width: 480px) {
    margin-top: 2px;
  }
`;

export const CheckboxLabel = styled.label`
  min-width: 0;
  line-height: 20px;
  overflow-wrap: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 19px;
  }
`;

export const MarketingConsentWrapper = styled.div`
  position: relative;

  font-size: 14px;
  gap: 8px;
  line-height: 20px;
  font-weight: 400;
  color: #0f172a;
  padding: 12px 24px 24px 24px;
  background: ${(props) => (props.isChecked ? "#F0FDF4" : "#f9fafb")};

  @media (max-width: 768px) {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
  }

  @media (max-width: 480px) {
    gap: 10px;
    padding: 14px;
  }
`;

export const MarketingConsent = styled.div`
  position: absolute;
  top: 12px;
  left: 75px;

  @media (max-width: 768px) {
    position: static;
    min-width: 0;
    line-height: 20px;
    overflow-wrap: break-word;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 19px;
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ConsentToggle = styled.div`
  min-width: 40px;
  min-height: 22px;
  width: 40px;
  height: 22px;
  background: ${(props) => (props.isAgreed ? "green" : "#D1D5DB")};
  border-radius: 12.8px;
  position: relative;
  margin-top: 4px;
  border: none;
  cursor: pointer;
  flex-shrink: 0;

  :after {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    top: 50%;
    left: 1.5px;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(-50%)
      ${(props) => props.isAgreed && "translateX(16.5px)"};
  }
`;

export const AgreementLinkButton = styled.button`
  display: inline;
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  color: #1d4ed8;
  font: inherit;
  line-height: inherit;
  text-align: left;
  text-decoration: underline;
  vertical-align: baseline;
  cursor: pointer;
  overflow-wrap: break-word;
`;

export const AgreementLinkText = styled.span`
  color: #1d4ed8;
  cursor: pointer;
  text-decoration: underline;
`;
